module.exports = __webpack_public_path__ + "962478ebf08c9b4cbd1ba55e6079f68a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-store-links/sp-store-links.html
// module id = 1142
// module chunks = 0